import { DocumentoSpesaVO } from "./documento-spesaVO";
import { TipoBeneficiarioEnum } from "../enum/tipo-beneficiario-enum";

export class AnagraficaBeneficiarioVO {
  denominazione: string;
  tipoBeneficiario: TipoBeneficiarioEnum;
  codiceFiscale: string;
  partitaIva: string;
  indirizzo: string;
  classeContabile: string;
  codiceFornitore: string;
  iban?: string;
  index: number;
  cap: string;
  comune: string;
  provincia: string;
  documentiSpesa: DocumentoSpesaVO[];
  ritenuta: number;
  protocolliDomanda: string;
  codiceCor: string;
  noteAggiuntive: string;

}
